import { MantineThemeOverride } from '@mantine/core';

export type JsonInputTheme = NonNullable<MantineThemeOverride['components']>['JsonInput'];

export const JsonInput: JsonInputTheme = {
  // todo: define
};
